import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import translationEN from "./languages/en/translation.json";
import translationFR from "./languages/fr/translation.json";
import translationAR from "./languages/ar/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
  ar: {
    translation: translationAR,
  },
};

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
    },
  });

/** RTL for investor SA UI; safe before/without i18next.dir on a stub instance. */
export function layoutDir(language) {
  const lng = language || i18n.language || "en";
  if (typeof i18n.dir === "function") {
    return i18n.dir(lng);
  }
  return String(lng).startsWith("ar") ? "rtl" : "ltr";
}

export default i18n;
